import React from "react";
import { Link } from "react-router-dom";
import * as ROUTES from "../config/Routes";

const BackButton = () => {
  return (
    <div>
      <Link
        to={ROUTES.HOME}
        style={{
          textDecoration: "underline",
          color: "#aac1dc",
        }}
      >
        <span>Back to homepage </span>
      </Link>
    </div>
  );
};

export default BackButton;
